import React, { Component } from "react";
import { Table, Button, Col, Row, Text } from "antd";
import axios from "axios";
import PrintModalEtiqueta from '../components/PrintModalEtiqueta';
import Barcode from "react-barcode";
import numeral from "numeral";
import "./Relatorios.css";
import Colors from "../utils/Colors";

const { Column } = Table;

class EtiquetasPrintModal extends Component {
    state = {
        listaRegistros: [],
        atualizouLista: false,
        visualizar: false,
        carregando: false,

        // listaRegistros: [
        //     // { item: 0, descr: '', preco: 0, },
        //     // { item: 0, descr: '', preco: 0, },
        //     // { item: 0, descr: '', preco: 0, },
        //     // { item: 0, descr: '', preco: 0, },
        //     { seq: 1, item: 999999, descr: 'BLUSA - P - VERMELHO - TESTE TESTANDO TESTADO', preco: 97, },
        //     { seq: 2, item: 888888, descr: 'CALÇA - G - ESTAMPADO', preco: 197, },
        //     { seq: 3, item: 100, descr: 'CAMISA BRANCA - P - Branco', preco: 229, },
        //     { seq: 4, item: 155, descr: 'BATA - M - VERMELHO', preco: 186, },
        //     { seq: 5, item: 61, descr: 'CALÇA SKINY - 36 - Preto', preco: 186, },
        //     { seq: 6, item: 132, descr: 'JAQUETA COURO - 36 - AMARELO', preco: 349, },
        //     { seq: 7, item: 36, descr: 'BLUSA - P - VERMELHO - TESTE TESTANDO TESTADO', preco: 97, },
        //     { seq: 8, item: 100, descr: 'CAMISA BRANCA - P - Branco', preco: 229, },
        //     { seq: 9, item: 151, descr: 'CALÇA - G - ESTAMPADO', preco: 197, },
        //     { seq: 10, item: 36, descr: 'BLUSA - P - VERMELHO - TESTE TESTANDO TESTADO', preco: 97, },
        //     { seq: 11, item: 132, descr: 'JAQUETA COURO - 36 - AMARELO', preco: 349, },
        //     { seq: 12, item: 36, descr: 'BLUSA - P - VERMELHO - TESTE TESTANDO TESTADO', preco: 97, },
        //     { seq: 13, item: 36, descr: 'BLUSA - P - VERMELHO - TESTE TESTANDO TESTADO', preco: 97, },
        //     { seq: 14, item: 36, descr: 'BLUSA - P - VERMELHO - TESTE TESTANDO TESTADO', preco: 97, },
        //     { seq: 15, item: 36, descr: 'BLUSA - P - VERMELHO - TESTE TESTANDO TESTADO', preco: 97, },
        //     { seq: 16, item: 36, descr: 'BLUSA - P - VERMELHO - TESTE TESTANDO TESTADO', preco: 97, },
        //     { seq: 17, item: 36, descr: 'BLUSA - P - VERMELHO - TESTE TESTANDO TESTADO', preco: 97, },
        //     { seq: 18, item: 36, descr: 'BLUSA - P - VERMELHO - TESTE TESTANDO TESTADO', preco: 97, },
        //     { seq: 19, item: 36, descr: 'BLUSA - P - VERMELHO - TESTE TESTANDO TESTADO', preco: 97, },
        //     { seq: 20, item: 36, descr: 'BLUSA - P - VERMELHO - TESTE TESTANDO TESTADO', preco: 97, },
        //     { seq: 21, item: 36, descr: 'BLUSA - P - VERMELHO - TESTE TESTANDO TESTADO', preco: 97, },
        //     { seq: 22, item: 36, descr: 'BLUSA - P - VERMELHO - TESTE TESTANDO TESTADO', preco: 97, },
        //     { seq: 23, item: 36, descr: 'BLUSA - P - VERMELHO - TESTE TESTANDO TESTADO', preco: 97, },
        //     { seq: 24, item: 36, descr: 'BLUSA - P - VERMELHO - TESTE TESTANDO TESTADO', preco: 97, },
        //     { seq: 25, item: 36, descr: 'BLUSA - P - VERMELHO - TESTE TESTANDO TESTADO', preco: 97, },
        //     { seq: 26, item: 36, descr: 'BLUSA - P - VERMELHO - TESTE TESTANDO TESTADO', preco: 97, },
        //     { seq: 27, item: 36, descr: 'BLUSA - P - VERMELHO - TESTE TESTANDO TESTADO', preco: 97, },
        //     { seq: 28, item: 36, descr: 'BLUSA - P - VERMELHO - TESTE TESTANDO TESTADO', preco: 97, },
        //     { seq: 29, item: 36, descr: 'BLUSA - P - VERMELHO - TESTE TESTANDO TESTADO', preco: 97, },
        //     { seq: 30, item: 36, descr: 'BLUSA - P - VERMELHO - TESTE TESTANDO TESTADO', preco: 97, },
        //     { seq: 31, item: 36, descr: 'BLUSA - P - VERMELHO - TESTE TESTANDO TESTADO', preco: 97, },
        //     { seq: 32, item: 36, descr: 'BLUSA - P - VERMELHO - TESTE TESTANDO TESTADO', preco: 97, },
        //     { seq: 33, item: 36, descr: 'BLUSA - P - VERMELHO - TESTE TESTANDO TESTADO', preco: 97, },
        //     { seq: 16, item: 36, descr: 'BLUSA - P - VERMELHO - TESTE TESTANDO TESTADO', preco: 97, },
        //     { seq: 16, item: 36, descr: 'BLUSA - P - VERMELHO - TESTE TESTANDO TESTADO', preco: 97, },
        //     { seq: 16, item: 36, descr: 'BLUSA - P - VERMELHO - TESTE TESTANDO TESTADO', preco: 97, },
        //     { seq: 16, item: 36, descr: 'BLUSA - P - VERMELHO - TESTE TESTANDO TESTADO', preco: 97, },
        //     { seq: 16, item: 36, descr: 'BLUSA - P - VERMELHO - TESTE TESTANDO TESTADO', preco: 97, },
        //     { seq: 16, item: 36, descr: 'BLUSA - P - VERMELHO - TESTE TESTANDO TESTADO', preco: 97, },
        //     { seq: 16, item: 36, descr: 'BLUSA - P - VERMELHO - TESTE TESTANDO TESTADO', preco: 97, },
        //     { seq: 16, item: 36, descr: 'BLUSA - P - VERMELHO - TESTE TESTANDO TESTADO', preco: 97, },
        //     { seq: 16, item: 36, descr: 'BLUSA - P - VERMELHO - TESTE TESTANDO TESTADO', preco: 97, },
        //     { seq: 16, item: 36, descr: 'BLUSA - P - VERMELHO - TESTE TESTANDO TESTADO', preco: 97, },
        //     { seq: 16, item: 36, descr: 'BLUSA - P - VERMELHO - TESTE TESTANDO TESTADO', preco: 97, },
        //     { seq: 16, item: 36, descr: 'BLUSA - P - VERMELHO - TESTE TESTANDO TESTADO', preco: 97, },
        //     { seq: 16, item: 36, descr: 'BLUSA - P - VERMELHO - TESTE TESTANDO TESTADO', preco: 97, },
        //     { seq: 16, item: 36, descr: 'BLUSA - P - VERMELHO - TESTE TESTANDO TESTADO', preco: 97, },
        //     { seq: 16, item: 36, descr: 'BLUSA - P - VERMELHO - TESTE TESTANDO TESTADO', preco: 97, },
        //     { seq: 16, item: 36, descr: 'BLUSA - P - VERMELHO - TESTE TESTANDO TESTADO', preco: 97, },
        //     { seq: 16, item: 36, descr: 'BLUSA - P - VERMELHO - TESTE TESTANDO TESTADO', preco: 97, },
        //     { seq: 16, item: 36, descr: 'BLUSA - P - VERMELHO - TESTE TESTANDO TESTADO', preco: 97, },
        //     { seq: 16, item: 36, descr: 'BLUSA - P - VERMELHO - TESTE TESTANDO TESTADO', preco: 97, },
        //     { seq: 16, item: 36, descr: 'BLUSA - P - VERMELHO - TESTE TESTANDO TESTADO', preco: 97, },
        //     { seq: 16, item: 36, descr: 'BLUSA - P - VERMELHO - TESTE TESTANDO TESTADO', preco: 97, },
        //     { seq: 16, item: 36, descr: 'BLUSA - P - VERMELHO - TESTE TESTANDO TESTADO', preco: 97, },
        //     { seq: 16, item: 36, descr: 'BLUSA - P - VERMELHO - TESTE TESTANDO TESTADO', preco: 97, },
        //     { seq: 16, item: 36, descr: 'BLUSA - P - VERMELHO - TESTE TESTANDO TESTADO', preco: 97, },
        //     { seq: 16, item: 36, descr: 'BLUSA - P - VERMELHO - TESTE TESTANDO TESTADO', preco: 97, },
        //     { seq: 16, item: 36, descr: 'BLUSA - P - VERMELHO - TESTE TESTANDO TESTADO', preco: 97, },
        //     { seq: 16, item: 36, descr: 'BLUSA - P - VERMELHO - TESTE TESTANDO TESTADO', preco: 97, },
        //     { seq: 16, item: 36, descr: 'BLUSA - P - VERMELHO - TESTE TESTANDO TESTADO', preco: 97, },
        //     { seq: 16, item: 36, descr: 'BLUSA - P - VERMELHO - TESTE TESTANDO TESTADO', preco: 97, },
        //     { seq: 16, item: 36, descr: 'BLUSA - P - VERMELHO - TESTE TESTANDO TESTADO', preco: 97, },
        //     { seq: 16, item: 36, descr: 'BLUSA - P - VERMELHO - TESTE TESTANDO TESTADO', preco: 97, },
        //     { seq: 16, item: 36, descr: 'BLUSA - P - VERMELHO - TESTE TESTANDO TESTADO', preco: 97, },
        // ],
    }

    componentDidUpdate(propsAnterior, stateAnterior) {
        // console.log('componentDidUpdate')
        if ((this.state.visualizar) && (!this.state.atualizouLista)) {
            // console.log('componentDidUpdate OK OK')
            this.setState({
                listaRegistros: this.props.listaRegistros ? this.props.listaRegistros : [],
                posicao: this.props.posicao ? this.props.posicao : 1,
                atualizouLista: true,
            });
        }
    }

    onCancelar = () => {
        this.setState({
            visualizar: false,
            atualizouLista: false,
        })
    }

    onVisualizar = () => {
        this.setState({
            visualizar: true,
            atualizouLista: false,
        })
    }

    renderValor = (vlr) => {
        return (
            <span> {numeral(parseFloat(vlr)).format('0,000.00')} </span>
        );
    };



    renderEtiqueta = () => {
        // console.log('renderEtiqueta OK');
        const zeroPad = (num, places) => String(num).padStart(places, '0');

        // const listaRegistros = [...this.state.listaRegistros];

        // console.log('renderEtiqueta listaRegistros1: ', this.state.listaRegistros);
        const listaRegistros = [];
        let qtdeEtiq = 0;
        for (var x in this.state.listaRegistros) {
            qtdeEtiq = this.state.listaRegistros[x].qtde;
            for (let $i = 1; $i <= qtdeEtiq; $i++) {
                listaRegistros.push({
                    idf: String(this.state.listaRegistros[x].idf),
                    item: String(this.state.listaRegistros[x].item),
                    descr: this.state.listaRegistros[x].descr,
                    preco: this.state.listaRegistros[x].preco,
                })
            }
        };
        // console.log('renderEtiqueta listaRegistros2: ', listaRegistros);

        if (this.state.posicao > 1) {
            for (let $i = 1; $i < this.state.posicao; $i++) {
                listaRegistros.unshift({
                    idf: 0,
                    item: 0,
                    descr: '',
                });
            }
        }

        const content = listaRegistros.map((post, index) =>
            <Col xs={4} style={{ fontSize: 10, textAlign: "left", marginBottom: 13, height: 77, width: 130, marginRight: index === 4 || index === 9 || index === 14 || index === 19 || index === 24 || index === 29 || index === 34 || index === 39 || index === 44 || index === 49 || index === 54 || index === 59 || index === 64 ? -10 : 40 }} >
                {post.item ? (
                    <div>
                        <Col xs={12} style={{ fontSize: 10, textAlign: "left" }} >
                            <span style={{ fontWeight: "bold" }}>Cod: </span>
                            <span>{post.item ? post.item : 'X'}</span>
                        </Col>
                        <Col xs={12} style={{ fontSize: 10, textAlign: "right", fontWeight: "bold" }} >
                            <span>R$ {this.renderValor(post.preco)}</span>
                        </Col>
                        <Col xs={24} style={{ fontSize: 7, height: 22, textAlign: "left" }} >
                            <span>{post.descr ? post.descr : 'XX'}</span>
                        </Col>
                        <Col xs={24} style={{ textAlign: "center" }} >
                            <span>
                                <Barcode
                                    value={post.item ? zeroPad(post.item, 9) : '1'}
                                    height="20"
                                    fontSize="8"
                                    width="1%"
                                    marginTop="2"
                                    marginBottom="0"
                                    textMargin="0"
                                />
                            </span>
                        </Col>
                    </div>
                ) : null}
            </Col>
        );

        return (
            <div style={{ marginTop: 22, paddingLeft: -15 }}>
                {content}
            </div>
        );


        // return (
        //     <div style={{ marginTop: 22, paddingLeft: -15 }} >
        //         <Col xs={4} style={{ fontSize: 10, textAlign: "left", marginBottom: 13, width: 130, marginRight: 40 }} >
        //             <Col xs={12} style={{ fontSize: 10, textAlign: "left" }} >
        //                 <span style={{ fontWeight: "bold" }}>Cod: </span>
        //                 <span>{999999}</span>
        //             </Col>
        //             <Col xs={12} style={{ fontSize: 10, textAlign: "right", fontWeight: "bold" }} >
        //                 <span>R$ {this.renderValor("1000")}</span>
        //             </Col>
        //             <Col xs={24} style={{ fontSize: 7, height: 22, textAlign: "left" }} >
        //                 <span>{"TESTE TESTANDO TESTADO 11111 22222 33333 44444 55555"}</span>
        //             </Col>
        //             <Col xs={24} style={{ textAlign: "center" }} >
        //                 <span>
        //                     <Barcode
        //                         value={zeroPad(123456, 9)}
        //                         height="20"
        //                         fontSize="8"
        //                         width="1%"
        //                         marginTop="2"
        //                         marginBottom="0"
        //                         textMargin="0"
        //                     />
        //                 </span>
        //             </Col>
        //         </Col>
        //         <Col xs={4} style={{ fontSize: 10, textAlign: "left", marginBottom: 13, width: 130, marginRight: 40 }} >
        //             <Col xs={12} style={{ fontSize: 10, textAlign: "left" }} >
        //                 <span style={{ fontWeight: "bold" }}>Cod: </span>
        //                 <span>{999999}</span>
        //             </Col>
        //             <Col xs={12} style={{ fontSize: 10, textAlign: "right", fontWeight: "bold" }} >
        //                 <span>R$ {this.renderValor("1000")}</span>
        //             </Col>
        //             <Col xs={24} style={{ fontSize: 7, height: 22, textAlign: "left" }} >
        //                 <span>{"TESTE TESTANDO TESTADO 11111 22222 33333 44444 55555"}</span>
        //             </Col>
        //             <Col xs={24} style={{ textAlign: "center" }} >
        //                 <span>
        //                     <Barcode
        //                         value={zeroPad(123456, 9)}
        //                         height="20"
        //                         fontSize="8"
        //                         width="1%"
        //                         marginTop="2"
        //                         marginBottom="0"
        //                         textMargin="0"
        //                     />
        //                 </span>
        //             </Col>
        //         </Col>
        //         <Col xs={4} style={{ fontSize: 10, textAlign: "left", marginBottom: 13, width: 130, marginRight: 40 }} >
        //             <Col xs={12} style={{ fontSize: 10, textAlign: "left" }} >
        //                 <span style={{ fontWeight: "bold" }}>Cod: </span>
        //                 <span>{999999}</span>
        //             </Col>
        //             <Col xs={12} style={{ fontSize: 10, textAlign: "right", fontWeight: "bold" }} >
        //                 <span>R$ {this.renderValor("1000")}</span>
        //             </Col>
        //             <Col xs={24} style={{ fontSize: 7, height: 22, textAlign: "left" }} >
        //                 <span>{"TESTE TESTANDO TESTADO 11111 22222 33333 44444 55555"}</span>
        //             </Col>
        //             <Col xs={24} style={{ textAlign: "center" }} >
        //                 <span>
        //                     <Barcode
        //                         value={zeroPad(123456, 9)}
        //                         height="20"
        //                         fontSize="8"
        //                         width="1%"
        //                         marginTop="2"
        //                         marginBottom="0"
        //                         textMargin="0"
        //                     />
        //                 </span>
        //             </Col>
        //         </Col>
        //         <Col xs={4} style={{ fontSize: 10, textAlign: "left", marginBottom: 13, width: 130, marginRight: 40 }} >
        //             <Col xs={12} style={{ fontSize: 10, textAlign: "left" }} >
        //                 <span style={{ fontWeight: "bold" }}>Cod: </span>
        //                 <span>{999999}</span>
        //             </Col>
        //             <Col xs={12} style={{ fontSize: 10, textAlign: "right", fontWeight: "bold" }} >
        //                 <span>R$ {this.renderValor("1000")}</span>
        //             </Col>
        //             <Col xs={24} style={{ fontSize: 7, height: 22, textAlign: "left" }} >
        //                 <span>{"TESTE TESTANDO TESTADO 11111 22222 33333 44444 55555"}</span>
        //             </Col>
        //             <Col xs={24} style={{ textAlign: "center" }} >
        //                 <span>
        //                     <Barcode
        //                         value={zeroPad(123456, 9)}
        //                         height="20"
        //                         fontSize="8"
        //                         width="1%"
        //                         marginTop="2"
        //                         marginBottom="0"
        //                         textMargin="0"
        //                     />
        //                 </span>
        //             </Col>
        //         </Col>
        //         <Col xs={4} style={{ fontSize: 10, textAlign: "left", marginBottom: 13, width: 130, marginRight: -10 }} >
        //             <Col xs={12} style={{ fontSize: 10, textAlign: "left" }} >
        //                 <span style={{ fontWeight: "bold" }}>Cod: </span>
        //                 <span>{999999}</span>
        //             </Col>
        //             <Col xs={12} style={{ fontSize: 10, textAlign: "right", fontWeight: "bold" }} >
        //                 <span>R$ {this.renderValor("1000")}</span>
        //             </Col>
        //             <Col xs={24} style={{ fontSize: 7, height: 22, textAlign: "left" }} >
        //                 <span>{"TESTE TESTANDO TESTADO 11111 22222 33333 44444 55555"}</span>
        //             </Col>
        //             <Col xs={24} style={{ textAlign: "center" }} >
        //                 <span>
        //                     <Barcode
        //                         value={zeroPad(123456, 9)}
        //                         height="20"
        //                         fontSize="8"
        //                         width="1%"
        //                         marginTop="2"
        //                         marginBottom="0"
        //                         textMargin="0"
        //                     />
        //                 </span>
        //             </Col>
        //         </Col>
        //     </div>
        // );
    };


    render() {
        const { carregando, visualizar } = this.state;

        // console.log('EtiquetasPrintModal - props: ', this.props);
        // console.log('EtiquetasPrintModal - state: ', this.state);

        return (
            <span>
                <Button onClick={this.onVisualizar}>
                    Impressão
                </Button>

                <PrintModalEtiqueta
                    visible={visualizar}
                    onCancel={this.onCancelar}
                >
                    <Row>
                        {this.renderEtiqueta()}
                    </Row>

                </PrintModalEtiqueta>
            </span>
        );
    }
}

export default EtiquetasPrintModal;


{/* <Barcode
value="1234567890"
//   width: 2,
//   height: 100,
//   format: "CODE128",
//   displayValue: true,
//   fontOptions: "",
//   font: "monospace",
//   textAlign: "center",
//   textPosition: "bottom",
//   textMargin: 2,
//   fontSize: 20,
//   background: "#ffffff",
//   lineColor: "#000000",
//   margin: 10,
//   marginTop: undefined,
//   marginBottom: undefined,
//   marginLeft: undefined,
//   marginRight: undefined
/> */}



// WEBPACK FOOTER //
// ./src/relatorios/EtiquetasPrintModal.js